import { render, staticRenderFns } from "./ChangeMt5Password.vue?vue&type=template&id=5d20a5f4"
import script from "./ChangeMt5Password.vue?vue&type=script&lang=js"
export * from "./ChangeMt5Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports